module.exports = {"id":"dp3_1l1q1","text":"Developing digital content","instructions":"Using different content creation tools can help achieve different content goals.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.1","questionType":"PickOne","random":false,"options":[{"id":"dp3_1l1q1-a1","text":"True","score":1.8},{"id":"dp3_1l1q1-a2","text":"Not sure","score":0},{"id":"dp3_1l1q1-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.1/l1q1.json
// module id = 1110
// module chunks = 41